import { apiSlice } from '@/store/api/apiSlice';

export interface NextWeekPredictionResponse {
  prediction: string;
}

export interface NextWeekPredictionArgs {
  rashi: string;
}

export const nextWeekPredictionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNextWeekPrediction: builder.query<
      NextWeekPredictionResponse,
      NextWeekPredictionArgs
    >({
      query: ({ rashi }) => ({
        url: 'predictions/next-week',
        method: 'GET',
        params: {
          rashi,
        },
      }),
    }),
  }),
});

export const {
  useGetNextWeekPredictionQuery,
  useLazyGetNextWeekPredictionQuery,
} = nextWeekPredictionApi;
